import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity } from 'lodash'
import { TrackedLink } from 'components/Buttons'

import { getPackageVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'

export class PackageForm extends Component {

  render = () => (<div>
    {this.props.packages && this.props.packages.length > 0 &&
      <div className="customize-form">
        <div className="packages-header">OR, SELECT AN EXPRESS PACKAGE</div>
        <div className="packages">
          {this.props.packages.map(pack => (
          <div key={pack.customInstanceId}>
              <TrackedLink trackingData={"Package:" + (pack.title || pack.label)} 
                to="confirm" className="select-package-link" type="button" onClick={() => this.props.onSelectInstance(pack.customInstanceId)}>
                {pack.title || pack.label}
              </TrackedLink>
            </div>
          ))}
        </div>
        <div className="clearfix"></div>
      </div>
    }
  </div>)
}

PackageForm.defaultProps = {
  onSelectField: identity,
};

const mapStateToProps = (state, ownProps) => {
  return { ...getPackageVM(state.customize) }
}
const mapDispatchToProps = {
  onSelectInstance: actions.loadInstance
}

export default connect(mapStateToProps, mapDispatchToProps)(PackageForm);

